import { render, staticRenderFns } from "./SzechenyiPlan.vue?vue&type=template&id=35216152&scoped=true&"
import script from "./SzechenyiPlan.vue?vue&type=script&lang=js&"
export * from "./SzechenyiPlan.vue?vue&type=script&lang=js&"
import style0 from "./SzechenyiPlan.vue?vue&type=style&index=0&id=35216152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35216152",
  null
  
)

export default component.exports